<script setup lang="ts">

//vue
import { onMounted, reactive,} from "vue";
import { useRouter, useRoute } from 'vue-router';

//servicos
import * as service from "@/services/BoletosService";
import { fdata, f2dec } from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import Loading from "@/components/Loading/index.vue"

const router = useRouter();
const route = useRoute();

var controle = reactive({
    filtros: {
        retornoId: 0 
    } ,
    itens: [] as service.BoletoRelDif[],
    totais: {
        qtde: 0,
        valorDocumento: 0,
        valorMoraJuros: 0,
        valorPago: 0,
        valorDiferenca: 0,
        valorOutrosCreditos: 0,
        valorDesconto: 0,
        valorReceberMulta: 0,
        valorReceberJuros: 0,
        valorReceber: 0,
    },
    id: 0 as number,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",

    item: {} as service.BoletoRelDif,
    janDetalhes: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,

});

onMounted(() => {
    controle.filtros.retornoId = parseInt(route.params.id.toString());
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.itens = [] as service.BoletoRelDif[];
    console.log("pesquisar");

    service.obterRetornoDiferencas(controle.filtros.retornoId as number)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.itens = r as service.BoletoRelDif[];

            controle.itens.forEach((boleto) => {
                controle.totais.qtde++;
                controle.totais.valorDocumento += (boleto.valorDocumento ?? 0);
                controle.totais.valorPago += (boleto.valorPago ?? 0);
                controle.totais.valorReceber += (boleto.valorReceber ?? 0);
                controle.totais.valorDiferenca =  controle.totais.valorPago - controle.totais.valorReceber;
                controle.totais.valorReceberJuros += (boleto.valorReceberJuros ?? 0);
            });

            

        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.itens = controle.itens.sort((a, b) => (a[coluna as keyof service.BoletoRelDif] > b[coluna as keyof service.BoletoRelDif]) ? 1 : ((b[coluna as keyof service.BoletoRelDif] > a[coluna as keyof service.BoletoRelDif]) ? -1 : 0));
    else
        controle.itens = controle.itens.sort((a, b) => (a[coluna as keyof service.BoletoRelDif] < b[coluna as keyof service.BoletoRelDif]) ? 1 : ((b[coluna as keyof service.BoletoRelDif] < a[coluna as keyof service.BoletoRelDif]) ? -1 : 0));
}

</script>

<template>
    <Loading :isLoading="controle.loading" :mensagem="controle.status" />
    
    <div class="p-2 bg-light">
        <div class="row mb-2 d-print-none">
            <div class="col-md-3 col-4 fs-6 fw-bold">
                Diferenças
            </div>

            <div class="col-md-3 col-4 fs-6 fw-bold">
                Retorno:  {{ controle.filtros.retornoId }}
            </div>

            <div class="col-md-3 col-4 fs-6 fw-bold">
                
            </div>

            <div class="col-md-3 col-4 fs-6 fw-bold">
                <a class="btn btn-primary btn-sm float-end" style="cursor: pointer;">
                    <i class="fa fa-print"></i> Imprimir
                </a>
            </div>
        </div>

        <div class="row pe-2">
            <div class="col-md-12 div-table-boletos pe-2" >
                <table class="table table-striped table-hover table-sm table-bordered" >
                    <thead class="th-fixed">
                        <tr>
                            <th class="text-start d-print-none" @click="ordenarPor('boletoId')" >Id</th>
                            <th class="text-start" @click="ordenarPor('nossoNumero')" >Nº Documento</th>
                            <th class="text-start" @click="ordenarPor('descricaoTipoOcorrencia')" >Tipo Ocorrência</th>
                            <th class="text-end " @click="ordenarPor('clienteId')" >Cliente</th>
                            <th class="text-start" @click="ordenarPor('clienteNome')"  >Razão social</th>
                            <th class="text-center " @click="ordenarPor('dataVencimento')" >Dt. Vencto</th>
                            <th class="text-center " @click="ordenarPor('dataVencimento')" >Dt. Pagto</th>
                            <th class="text-center " @click="ordenarPor('dataVencimento')" >Dias Atraso</th>
                            
                            <th class="text-end" @click="ordenarPor('vendedorNome')" >Valor R$</th>
                            <th class="text-end " @click="ordenarPor('vendedorNome')" >Desc/Acres R$</th>
                            <th class="text-end" @click="ordenarPor('nomeCidade')" >Vlr Pago R$</th>
                            <th class="text-end" @click="ordenarPor('nomeCidade')" >Receber R$</th>

                            <th class="text-end" @click="ordenarPor('vendedorNome')" >Diferença R$</th>
                            <th class="text-end d-print-none"  ></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="controle.pesquisando == true">
                            <td colspan="15" class="text-center">
                                <div class="d-inline">
                                    <i class="fa fa-cog fa-spin"></i>
                                    Pesquisando... 
                                </div>
                            </td>
                        </tr>
                        <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                            <td colspan="15" class="text-center">
                                <div class="d-inline">
                                    <i class="fa fa-exclamation"></i>
                                    {{ controle.erro }}
                                </div>
                                <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                            </td>
                        </tr>

                        <tr v-for="(item, idx) in controle.itens" :key="idx" >

                            <td class="text-start d-print-none" data-label="Boleto Id" > 
                                {{ item.boletoId }}
                            </td>
                            <td class="text-start" data-label="Nº Documento" > 
                                {{ item.numeroDocumento }}
                            </td>
                            <td class="text-start" data-label="Tipo Ocorrência" > 
                                {{ item.descricaoTipoOcorrencia }}
                            </td>
                            <td class="text-end " data-label="Cliente">
                                {{ item.clienteId }}  
                            </td>
                            <td class="text-start" data-label="Nome Cliente">
                                {{ item.nome }}  
                            </td>
                            <td class="text-center " data-label="Dt. Vencto">
                                {{ fdata(item.dataVencimento) }}  
                            </td>

                            <td class="text-center" data-label="Dt. Pagto">
                                {{ fdata(item.dataPagamento) }}  
                            </td>

                            <td class="text-center " data-label="Dias astraso">
                                {{ item.diasAtraso }}  
                            </td>

                            <td class="text-end" data-label="Valor R$">
                                {{ f2dec(item.valorDocumento) }}
                            </td>

                                <td class="text-end " data-label="Desc/Acresc R$">
                                {{ f2dec(item.valorMoraJuros + item.valorOutrosCreditos - item.valorDesconto) }}
                            </td>

                            <td class="text-end " data-label="Pago R$">
                                {{ f2dec(item.valorPago) }}
                            </td>


                            <td class="text-end" data-label="Receber R$"  >
                                {{ f2dec(item.valorReceber) }}
                            </td>

                            <td class="text-end" data-label="Diferença R$"  :class="item.valorDocumento - item.valorReceber > 0 ? 'text-primary':'text-danger'">
                                {{ f2dec( item.valorPago - item.valorReceber) }}
                            </td>
                            <td class="text-center d-print-none" data-label="Opções" >
                                <a title="Ver detalhes da diferença" class="" style="cursor: pointer;" @click="controle.item = item; controle.janDetalhes = true;">
                                    <i class="fa fa-search"></i>
                                </a> 
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="table-secondary fw-bold">
                            <td  class="text-end d-print-none"></td>
                            <td  class="text-end"></td>
                            <td  class="text-end"></td>
                            <td  class="text-start">{{ controle.itens.length }} Registros</td>
                            <td  class="text-end"></td>
                            <td  class="text-end"></td>
                            <td  class="text-end"></td>
                            <td class="text-end">{{ f2dec(controle.totais.valorDocumento) }}</td>
                            <td class="text-end ">{{ f2dec(controle.totais.valorMoraJuros + controle.totais.valorOutrosCreditos - controle.totais.valorDesconto) }}</td>
                            <td class="text-end ">{{ f2dec(controle.totais.valorPago) }}</td>
                            <td class="text-end">{{ f2dec(controle.totais.valorReceber) }}</td>
                            <td class="text-end">{{ f2dec(controle.totais.valorDiferenca) }}</td>
                            <td  class="text-end d-print-none"></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div> 
    </div>

    <MsgBox :id="'janDetalhes'" :exibir="controle.janDetalhes" 
    :botao-fechar="true" 
    :titulo="'Detalhes'" 
    :tamanho="'modal-lg'"
    @on-fechou="controle.janDetalhes = false">
        <div class="row">
            <div class="col-md-4">
                <div class="row">
                    <div class="col-md-12">
                        <b>Boleto Id:</b> {{ controle.item.boletoId }}
                    </div>
                    <div class="col-md-12">
                        <b>Nosso Número:</b> {{ controle.item.nossoNumero }}
                    </div>
                    <div class="col-md-12">
                        <b>Cliente:</b> {{ controle.item.clienteId }} - {{ controle.item.nome }}
                    </div>
                    <div class="col-md-12">
                        <b>Data vencimento:</b> {{ fdata(controle.item.dataVencimento) }}
                    </div>
                    <div class="col-md-12">
                        <b>Data dataPagamento:</b> {{ fdata(controle.item.dataPagamento) }}
                    </div>
                    <div class="col-md-12">
                        <b>Dias atraso:</b> {{ controle.item.diasAtraso }}
                    </div>
                </div>
            </div>
            
            <div class="col-md-4">
                <div class="row">
                    <div class="col-md-12">
                        <b>Sistema:</b>
                    </div>
                    <div class="col-md-12">
                        <b>Valor documento:</b> {{ f2dec(controle.item.valorDocumento) }}
                    </div>
                    <div class="col-md-12">
                        <b>Valor mora juros:</b> {{ f2dec(controle.item.valorReceberJuros) }}
                    </div>
                    <div class="col-md-12">
                        <b>Valor outros créditos:</b> {{ f2dec(controle.item.valorReceberMulta) }}
                    </div>
                    <div class="col-md-12">
                        <b>Valor desconto:</b> {{ f2dec(controle.item.valorDesconto) }}
                    </div>
                    <div class="col-md-12">
                        <b>Valor Receber:</b> {{ f2dec(controle.item.valorReceber) }}
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="row">
                    <div class="col-md-12">
                        <b>Banco:</b>
                    </div>
                    <div class="col-md-12">
                        <b>Valor documento:</b> {{ f2dec(controle.item.valorDocumento) }}
                    </div>
                    <div class="col-md-12">
                        <b>Valor mora juros:</b> {{ f2dec(controle.item.valorMoraJuros) }}
                        <span v-if="controle.item.valorMoraJuros != controle.item.valorReceberJuros" class="text-danger">
                            (Dif: {{ f2dec((controle.item.valorMoraJuros ?? 0) - (controle.item.valorReceberJuros ?? 0)) }})
                        </span>
                    </div>
                    <div class="col-md-12">
                        <b>Valor outros créditos:</b> {{ f2dec(controle.item.valorOutrosCreditos) }}
                        <span v-if="controle.item.valorOutrosCreditos != controle.item.valorReceberMulta" class="text-danger">
                            (Dif: {{ f2dec((controle.item.valorOutrosCreditos ?? 0) - (controle.item.valorReceberMulta ?? 0)) }})
                        </span>
                    </div>
                    <div class="col-md-12">
                        <b>Valor desconto:</b> {{ f2dec(controle.item.valorDesconto) }}
                        <span v-if="controle.item.valorDesconto != controle.item.valorDesconto" class="text-danger">
                            (Dif: {{ f2dec((controle.item.valorDesconto ?? 0) - (controle.item.valorDesconto ?? 0)) }})
                        </span>
                    </div>
                    <div class="col-md-12">
                        <b>Valor pago:</b> {{ f2dec(controle.item.valorPago) }}
                        <span v-if="controle.item.valorPago != controle.item.valorReceber" class="text-danger">
                            (Dif: {{ f2dec((controle.item.valorPago ?? 0) - (controle.item.valorReceber ?? 0)) }})
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </MsgBox>

    <nav class="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark border-top d-print-none">
        <div class="container-fluid">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    
                </ul>

                <div class="d-flex">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link" href="#" @click="router.back()">
                                <i class="fa fa-close"></i> Fechar
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
   

</template>

<style scoped>

.div-table-boletos {
    max-height: calc(100vh - 140px);
    min-height: calc(100vh - 140px);
    overflow: auto;
}

@media print {
    .div-table-boletos {
        max-height: fit-content;
        min-height: fit-content;
        overflow: none;
    }
}

.badge {
    font-size: 100%;
    cursor: pointer;
    text-wrap: wrap;
}

.table-selecao {
    color: #fff !important;
    background-color: #003b93 !important;
    --bs-table-bg-state: #0d6efd;
    --bs-table-color-state: #fff;
}

.opcoes {
    min-width: 95px;
}
</style>